import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/hero-mockup-poster.png")